/* Blastoys product page behaviour: gallery switching + variant selection.
   Ported from src/routes/product.$slug.tsx. Keeps the native Shopify product
   form intact — we only swap the hidden variant id, so cart/checkout is unchanged. */
(function () {
  'use strict';

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || '£{{amount}}').replace(/\{\{\s*amount\s*\}\}/, v);
  }

  function initGallery(root) {
    var stage = root.querySelector('[data-bt-stage]');
    if (!stage) return;
    var imgs = stage.querySelectorAll('img[data-idx]');
    var thumbs = root.querySelectorAll('.bt-pdp-thumb');
    var counter = root.querySelector('[data-bt-counter]');
    if (!thumbs.length) return;

    function show(idx) {
      imgs.forEach(function (im) { im.hidden = String(idx) !== im.dataset.idx; });
      thumbs.forEach(function (t) {
        t.setAttribute('aria-selected', t.dataset.idx === String(idx) ? 'true' : 'false');
      });
      if (counter) counter.textContent = ('0' + (idx + 1)).slice(-2);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.dataset.idx, 10)); });
    });
  }

  function initVariants(root) {
    var data = root.querySelector('[data-bt-variants]');
    var hidden = root.querySelector('[data-bt-variant-id]');
    if (!data || !hidden) return;

    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var atc = root.querySelector('[data-bt-atc]');
    var priceEl = root.querySelector('[data-bt-price]');
    var compareEl = root.querySelector('[data-bt-compare]');
    var fmt = (window.Shopify && window.Shopify.money_format) || '£{{amount}}';

    // Current selection, one entry per option position.
    var chosen = [];
    root.querySelectorAll('[data-bt-option-index]').forEach(function (grp) {
      var i = parseInt(grp.dataset.btOptionIndex, 10);
      var on = grp.querySelector('.bt-pdp-val[aria-pressed="true"]');
      chosen[i] = on ? on.dataset.btValue : null;
    });

    function match() {
      return variants.find(function (v) {
        return chosen.every(function (val, i) {
          return val == null || v.options[i] === val;
        });
      });
    }

    function apply() {
      var v = match();
      if (!v) return;
      hidden.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price, fmt);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price, fmt);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      // Keep the URL shareable, matching Shopify's own behaviour.
      var direct = root.querySelector('[data-bt-buynow]');
      if (direct) direct.setAttribute('href', '/cart/' + v.id + ':1');
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u);
      }
    }

    root.querySelectorAll('.bt-pdp-val').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = parseInt(btn.dataset.btOpt, 10);
        chosen[i] = btn.dataset.btValue;
        var grp = btn.closest('[data-bt-option-index]');
        grp.querySelectorAll('.bt-pdp-val').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        var label = grp.querySelector('[data-bt-opt-current]');
        if (label) label.textContent = btn.dataset.btValue;
        apply();
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-bt-section="product"]').forEach(function (sec) {
      if (sec.hasAttribute('data-bt-init')) return;
      sec.setAttribute('data-bt-init', '');
      initGallery(sec);
      initVariants(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
